type ModelEntry = { id: string };

export function latestStandardModel(
  runtime: string,
  models: readonly ModelEntry[],
): string | undefined {
  const candidates = models.flatMap(({ id }) => {
    const match =
      runtime === "claude_cli"
        ? /^claude-opus-(\d{1,2}(?:-\d{1,2})*)(?:-\d{8})?$/.exec(id)
        : runtime === "codex_cli"
          ? /^gpt-(\d+(?:\.\d+)*)(?:-(sol|terra))?$/.exec(id)
          : null;
    if (!match) return [];
    const version = match[1]!.split(/[.-]/).map(Number);
    if (runtime === "codex_cli" && version[0]! >= 6 && !match[2]) return [];
    return [{ id, version }];
  });
  candidates.sort((a, b) => {
    for (
      let index = 0;
      index < Math.max(a.version.length, b.version.length);
      index++
    ) {
      const difference = (b.version[index] ?? 0) - (a.version[index] ?? 0);
      if (difference) return difference;
    }
    return b.id.localeCompare(a.id);
  });
  return candidates[0]?.id;
}

export function followsStandardModel(template: {
  name?: string;
  is_builtin?: boolean;
  adapter_type?: string | null;
  adapter_config?: { model?: string; model_policy?: string } | null;
}): boolean {
  if (!template.is_builtin || template.name !== "Denker") return false;
  const config = template.adapter_config;
  if (config?.model_policy) return config.model_policy === "auto_standard";
  if (!config?.model) return true;
  const legacy =
    template.adapter_type === "claude_cli"
      ? ["sonnet", "claude-sonnet-4-6", "claude-sonnet-5", "claude-sonnet-5-5"]
      : template.adapter_type === "codex_cli"
        ? ["gpt-5.4", "gpt-5.4-mini", "gpt-5.6-terra"]
        : [];
  return legacy.includes(config.model);
}
